var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "customer_email_access-id",
                          name: "id",
                          type: "text-number",
                          maxlength: "20",
                          label: _vm.$t("Identificador"),
                          placeholder: _vm.$t("Identificador"),
                        },
                        model: {
                          value: _vm.filter.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "id", $$v)
                          },
                          expression: "filter.id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "customer_email_access-document",
                          name: "document",
                          type: "text-mask",
                          mask: ["###.###.###-##"],
                          label: _vm.$t("CPF"),
                          placeholder: _vm.$t("CPF"),
                        },
                        model: {
                          value: _vm.filter.document,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "document", $$v)
                          },
                          expression: "filter.document",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "customer_email_access-name",
                          name: "name",
                          type: "text",
                          maxlength: "150",
                          label: _vm.$t("Nome"),
                          placeholder: _vm.$t("Nome"),
                        },
                        model: {
                          value: _vm.filter.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "name", $$v)
                          },
                          expression: "filter.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.getData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            ref: "customer-email-access-table",
            staticClass: "bordered",
            attrs: {
              id: "customer-email-access-table",
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("CUSTOMER.NAME"),
                "male",
                _vm.queryExecuted
              ),
              fields: _vm.fields,
              items: _vm.customers,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(document)",
                fn: function (row) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm._f("cpfCnpj")(row.item.document)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(active)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: { status: row.item.active },
                    }),
                  ]
                },
              },
              {
                key: "cell(emailAccess)",
                fn: function (row) {
                  return [
                    _vm._v(" " + _vm._s(row.item.emailAccess || "") + " "),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "show-update":
                          _vm.hasEmailAccess(row.item) &&
                          _vm.$can("UpdateEmailAccess", "Customer"),
                        "show-delete": false,
                      },
                      on: {
                        update: function ($event) {
                          return _vm.onEditEmailAccess(row.item)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            { staticClass: "pt-1" },
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "customer-email-access-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "e-modal-custom-form",
        {
          ref: "modalEmailAccess",
          attrs: { title: _vm.$t("Alterar E-mail de Acesso") },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "d-flex flex-column", attrs: { md: "12" } },
                [
                  _c("FormulateInput", {
                    staticClass: "w-100 required",
                    attrs: {
                      id: "customer_email_access-edit-email",
                      name: "emailAccess",
                      type: "email",
                      maxlength: "254",
                      validation: "required|email",
                      label: _vm.$t("E-mail de Acesso"),
                      placeholder: _vm.$t("email@dominio.com"),
                    },
                    model: {
                      value: _vm.emailAccessForm.emailAccess,
                      callback: function ($$v) {
                        _vm.$set(_vm.emailAccessForm, "emailAccess", $$v)
                      },
                      expression: "emailAccessForm.emailAccess",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }